/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate", "EXPERIMENTAL_API_USAGE")

package features.socialMediaLinks.internal

import features.socialMediaLinks.models.SocialMediaLinksModel
import kangaroorewards.appsdk.core.io.IOResult
import kangaroorewards.appsdk.core.network.NetworkRequest

internal class SocialMediaLinksRequest : NetworkRequest() {

    suspend fun getSocialMediaLinks(
        overrideHeaders: Map<String, String>? = null,

    ): IOResult<SocialMediaLinksModel> {
        return safeNetworkCall {
            get(
                endpoint = SocialMediaLinksEndpoint,
                serverHostId = 0,
                overrideHeaders = overrideHeaders
            )
        }
    }
}
